var exports = {};
exports = {
  strings: {
    // Shown in the Informer if an upload is being canceled because it stalled for too long.
    timedOut: "Upload stalled for %{seconds} seconds, aborting."
  }
};
export default exports;